<script setup lang="ts">
const attrs = useAttrs()
const component = attrs.componentName
const fields: any = attrs.fields || {}

const currentComponent = computed(() => {
  switch (component) {
    case 'link':
      return resolveComponent('Action')
    case 'anchorLink':
      return resolveComponent('AnchorLink')
    case 'icon':
      return resolveComponent('Icon')
    default:
      return null
  }
})
</script>

<template>
  <component class="rich-text__inline-entry" :is="currentComponent" v-bind="fields" />
</template>

<style lang="postcss">
.rich-text__inline-entry {
  display: inline;

  &.action {
    display: inline-flex;
  }
}
</style>
